import React from 'react';
import { applyTypography, useT } from '@repo/common';
import { ReactComponent as InfoIcon24 } from '@repo/common/assets/icons/24px/icon_24px_info_outline.svg';
import { useGoogleMap } from '../hooks/useGoogleMap';

const LocationSection = ({
  meetingPoint = {
    name: '온유여월',
    address: '28-10 Jangan-dong, Paldal-gu, Suwon-si, Gyeonggi-do, South Korea',
    mapImage: '',
    placeId: null,
  },
}) => {
  const t = useT();
  // Google Maps 훅 사용
  const hasCoordinates =
    Number.isFinite(meetingPoint.latitude) &&
    Number.isFinite(meetingPoint.longitude);
  const { mapRef, mapError } = useGoogleMap(
    meetingPoint.address,
    hasCoordinates
      ? { lat: meetingPoint.latitude, lng: meetingPoint.longitude }
      : null,
  );

  return (
    <div className='flex flex-col items-start pb-[30px] pt-0 px-0 relative shrink-0 w-full tabletH:pb-[60px]'>
      <div className='bg-grayscale-gray00 flex flex-col items-start px-[24px] py-[30px] relative shadow-3 shrink-0 w-full tabletH:rounded-[50px] tabletH:px-[80px] tabletH:pt-[60px] tabletH:pb-[80px]'>
        {/* Header */}
        <div className='flex items-center pb-[8px] pt-0 px-0 relative shrink-0 w-full tabletH:pb-[24px]'>
          <p
            className={`${applyTypography(
              'b18Strong',
            )} tabletH:${applyTypography(
              'title1',
            )} text-text-primary shrink-0 leading-[1.5] tabletH:leading-[1.2]`}
          >
            {t("Where we'll meet", '만나는 장소')}
          </p>
          <div className='flex items-center justify-center pl-[6px] relative shrink-0 size-[20px] tabletH:pl-[8px] tabletH:pt-[4px] tabletH:size-[29px]'>
            <InfoIcon24 className='overflow-clip relative shrink-0 size-[20px] tabletH:size-[24px]' />
          </div>
        </div>

        {/* Address */}
        <div className='flex flex-col items-start max-w-[700px] pb-[16px] pt-0 px-0 relative shrink-0 w-full'>
          <div className='flex items-center justify-center pb-[4px] pt-0 px-0 relative shrink-0 w-full'>
            <p
              className={`flex-1 ${applyTypography(
                'b16Strong',
              )} text-text-tertiary shrink-0 whitespace-pre-wrap`}
              style={{ lineHeight: '1.5' }}
            >
              {meetingPoint.name}
            </p>
          </div>
          <p
            className={`${applyTypography('b14')} tabletH:${applyTypography(
              'b16',
            )} text-text-tertiary shrink-0 w-full whitespace-pre-wrap leading-[1.4] tabletH:leading-[1.5]`}
          >
            {meetingPoint.address}
          </p>
        </div>

        {/* Map */}
        <div className='h-[240px] max-w-[700px] overflow-clip relative rounded-[20px] shrink-0 w-full tabletH:h-[320px]'>
          {mapError ? (
            <div className='flex items-center justify-center h-full bg-grayscale-gray01 rounded-[20px]'>
              <p className={`${applyTypography('b16')} text-text-placeholder`}>
                {mapError}
              </p>
            </div>
          ) : (
            <div className='relative w-full h-full rounded-[20px] overflow-hidden'>
              <div
                ref={mapRef}
                className='w-full h-full rounded-[20px]'
                style={{ minHeight: '320px' }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LocationSection;
